import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapaService } from 'app/services/mapa/mapa.service';
import { LoadingComponent } from 'app/components/loading/loading.component';
import { PlantiosFalhas } from 'app/interfaces/PlantioFalha';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-dialog-de-falhas',
  standalone: true,
  imports: [CommonModule, LoadingComponent, MatTooltipModule, TranslocoModule],
  templateUrl: './dialog-de-falhas.component.html',
  styleUrl: './dialog-de-falhas.component.css'
})
export class DialogFalhasComponent implements OnInit {
  @Input() operacaoId!: number;
  public plantiosFalhas: PlantiosFalhas = [];
  public carregandoFalhas: boolean = true;
  protected readonly Math = Math;
  public coresRastros: any = {
    Falhas: '#F2C94E',
    Plantado: '#11644D'
  }
  @ViewChild('elemento') elemento!: ElementRef;
  visivel = true;
  
  constructor(
    private readonly mapaService: MapaService,
    private readonly translocoService: TranslocoService
  ) { }

  ngOnInit(): void {
    this.buscarPlantioFalhas();
  }

  public buscarPlantioFalhas(): void {
    if (this.operacaoId) {
      this.carregandoFalhas = true;
      this.mapaService.buscarFalhaMapa(this.operacaoId).subscribe(
        (plantiosFalhas) => {
          this.plantiosFalhas = plantiosFalhas;
          this.carregandoFalhas = false;
        }
      )
    }
  }
}
